const dev = {
  API_ENDPOINT_URL: '/api'
};

const prod = {
  API_ENDPOINT_URL: '/api'
};

const test = {
  API_ENDPOINT_URL: '/api'
};

const TOMTOM_API_KEY = process.env.REACT_APP_TOMTOM_API_KEY || '3leLsUqPvOuIbgeaTCndKwRCZf9RYBbo';

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
export const TOMTOM_KEY = TOMTOM_API_KEY;
